import { GetInputOptions } from "../getInput";
import { Input } from "../../../../common/components";
import React from "react";
import getTranslatedValue from "../../../../utils/CustomerTranslations/getTranslatedValue";
export const getFileInput = ({
  error,
  fileName,
  value,
  onChange,
  setError,
  onStartUpload,
  onStopUpload,
  question,
  tCustomer
}: GetInputOptions) => {
  const {
    name,
    required
  } = question;
  const id = question.id ?? name;
  const label = getTranslatedValue(`customQuestion.${id}`, "name", tCustomer, question);

  // Unlike other inputs, file inputs need setError, because input itself can
  // raise errors that need to be displayed. It shouldn't be possible for
  // setError to be undefined, but just in case, and to make TS stop complaining
  if (!setError) throw new Error(`setError not defined for file input on question ${id}`);
  // Similar to setError, we need onStartUpload and onStopUpload so that the
  // parent step won't navigate away while an upload is pending. Should always
  // be present, so the check is mostly just for TS.
  if (!onStartUpload) throw new Error(`onStartUpload not defined for file input on question ${id}`);
  if (!onStopUpload) throw new Error(`onStopUpload not defined for file input on question ${id}`);
  const onFileUpload = (key: string, fileName: string) => {
    onChange({
      fileName,
      id,
      newValue: key
    });
  };
  const onRemoveFile = () => {
    onChange({
      fileName: undefined,
      id,
      newValue: "",
      removeFile: true
    });
  };
  return <Input variant="file" id={id} value={value ? `${value}` : undefined} fileName={fileName} onFileUpload={onFileUpload} onRemoveFile={onRemoveFile} onStartUpload={onStartUpload} onStopUpload={onStopUpload} setError={setError} error={error} label={label} required={required} aria-label={label} data-sentry-element="Input" data-sentry-component="getFileInput" data-sentry-source-file="getFileInput.tsx" />;
};